import type { DrillDataLocalization, DrillLabelApiData } from '~/entities/drillLabel'
import { Vector3 } from 'three'
import { degToRad } from 'three/src/math/MathUtils'

const FEET_TO_METRES = 0.3048

export function applyLocalization(localization: DrillDataLocalization, label: DrillLabelApiData): DrillLabelApiData {
  localization = normalizeToMetres(localization)

  const api_coords = { x: label.x, y: label.y, z: label.z }
  const pt = new Vector3(label.x, label.z, -label.y)
  const Y_UP = new Vector3(0, 1, 0)

  pt.applyAxisAngle(Y_UP, degToRad(localization.rotation))

  return {
    ...label,
    x: pt.x - localization.easting,
    y: pt.y - localization.elevation,
    z: pt.z + localization.northing,
    api_coords: api_coords,
  }
}

function normalizeToMetres(localization: DrillDataLocalization): DrillDataLocalization {
  if (localization.unit_of_measurement === 'f') {
    return {
      ...localization,
      unit_of_measurement: 'm',
      northing: localization.northing * FEET_TO_METRES,
      easting: localization.easting * FEET_TO_METRES,
      elevation: localization.elevation * FEET_TO_METRES,
    }
  }
  return localization
}
